import { esFecha } from "../../../herramientas/Forms";

/**
 * Valida si se puede guardar el movimiento naviero.
 * @returns {{ habilitado: boolean, mensaje: string }}
 */
export const validarGuardado = ({
  idPlataforma,
  idCliente,
  idMovimientoTipo,
  destino,
  idCorredor,
  localidad,
  idTransportista,
  contenedorSize,
  contenedorTipo,
  contenedor,
  noContenedores,
  idOperacionTipo,
  po,
  noPo,
  ejecutivo,
  citaProgramada,
  citaProgramadaTerminal,
  citaColocacionGps,
  gpsTipoColocacion,
  tecnologia,
  estado,
  municipio,
  colonia,
  calle,
  numero,
  cp,
  modelot,
  marcat,
  colort,
  placat,
  economicot,
  placar,
  economicor,
  nombreOperador,
  medioContacto,
  coloca,
  colocacionDesechable,
  ov,
  contactoMonitoreo1,
  contactoMonitoreo2,
  contactoLineaColocacion1,
  contactoLineaColocacion2,
  razonSocialFacturar,
  referenciaFacturacion,
  isChecked,
  nuevo,
  modalidadesSeleccionadas,
}) => {
  const errores = [];
  const plt = idPlataforma.value;

  if (!plt) errores.push("Debes seleccionar una plataforma");
  if (!idCliente.value) errores.push("Debes seleccionar un cliente");
  if (!idMovimientoTipo.value) errores.push("Debes seleccionar un tipo de movimiento");
  if (![952].includes(plt) && !destino.length) errores.push("Debes capturar un destino");
  if (!idCorredor.value) errores.push("Debes seleccionar un corredor");
  if (![952, 1315, 4, 61, 1381, 1480].includes(plt) && (!localidad || !localidad.value))
    errores.push("Debes seleccionar una localidad");
  if (!idTransportista.value) errores.push("Debes seleccionar un transportista");
  if (!contenedorSize.value) errores.push("Debes seleccionar el tamaño de contenedor");
  if (!contenedorTipo.value) errores.push("Debes seleccionar el tipo de contenedor");
  if (contenedor.length !== Number(noContenedores) || contenedor.filter(c => c.length === 0).length)
    errores.push("Debes capturar todos los contenedores");
  if (!idOperacionTipo.value) errores.push("Debes seleccionar un tipo de operación");

  if ([952].includes(plt)) {
    if (po.length !== Number(noPo) || po.filter(p => p.length === 0).length)
      errores.push("Debes capturar todos los PO");
    if (!ejecutivo.value) errores.push("Debes seleccionar un ejecutivo");

    if ([1, 3].includes(idMovimientoTipo.value)) {
      if (!(esFecha(citaProgramada) && esFecha(citaProgramadaTerminal)
        && new Date(citaProgramadaTerminal).getTime() < new Date(citaProgramada).getTime()))
        errores.push("La cita programada terminal debe ser anterior a la cita programada (importación)");
    }
    if ([2, 4].includes(idMovimientoTipo.value)) {
      if (!(esFecha(citaProgramada) && esFecha(citaProgramadaTerminal)
        && new Date(citaProgramada).getTime() < new Date(citaProgramadaTerminal).getTime()))
        errores.push("La cita programada debe ser anterior a la cita programada terminal (exportación)");
    }
  }

  if (!gpsTipoColocacion || gpsTipoColocacion.value === 0)
    errores.push("Debes seleccionar un tipo de colocación GPS");

  if ([4, 61, 1381, 1480].includes(plt)) {
    if (!esFecha(citaColocacionGps))
      errores.push("Debes capturar la cita para colocación de GPS");
    if (gpsTipoColocacion && gpsTipoColocacion.value === 2 && !Boolean(tecnologia))
      errores.push("Debes capturar la tecnología");
    if (!estado || !municipio || !colonia || !calle || !numero || !cp)
      errores.push("Debes completar la dirección (estado, municipio, colonia, calle, número, CP)");
    if (gpsTipoColocacion && gpsTipoColocacion.value === 2) {
      if (!coloca || !colocacionDesechable)
        errores.push("Debes capturar la colocación y colocación desechable");
    }
    if (coloca === "Coloca cliente" && !ov)
      errores.push("Debes capturar la OV");
    if (!contactoMonitoreo1 || !contactoMonitoreo2 || !contactoLineaColocacion1 || !contactoLineaColocacion2)
      errores.push("Debes capturar los contactos de monitoreo y línea de colocación");
    if (!razonSocialFacturar || !razonSocialFacturar.trim().length)
      errores.push("Debes capturar la razón social a facturar");
    if (!modalidadesSeleccionadas || modalidadesSeleccionadas.length === 0)
      errores.push("Debes seleccionar al menos una modalidad de transporte");
    if (!isChecked) {
      if (!referenciaFacturacion || referenciaFacturacion.length !== Number(noContenedores) || referenciaFacturacion.some(r => !r || !r.trim().length))
        errores.push("Debes capturar todas las referencias de facturación");
    }
    if (nuevo && (gpsTipoColocacion && gpsTipoColocacion.value === 7 || (coloca && coloca.value === 'Coloca cliente'))) {
      if (!modelot || !marcat || !colort || !placat || !economicot || !placar || !economicor || !nombreOperador || !medioContacto)
        errores.push("Debes completar los datos del transporte y operador");
    }
  }

  return {
    habilitado: errores.length === 0,
    mensaje: errores.join(", "),
  };
};
